import EventsPane from './EventsPane';

export default EventsPane;
